import type { CMSData } from "@/cms/models";
import {
  showFormDateTimeFields,
  type SchedulingFormType,
} from "@/utils/form-scheduling";
import DateInput from "./DateInput";
import TextInput from "./TextInput";

interface FormDateTimeFieldsProps {
  cmsData: CMSData;
  form: SchedulingFormType;
  date?: string;
  time?: string;
  errors?: { date?: string[]; time?: string[] } | null;
}

export default function FormDateTimeFields({
  cmsData,
  form,
  date,
  time,
  errors,
}: FormDateTimeFieldsProps) {
  if (!showFormDateTimeFields(cmsData.forms, form)) return null;

  return (
    <>
      <DateInput
        cmsData={cmsData}
        name="date"
        label="Dato"
        defaultValue={date ?? ""}
        errors={errors?.date}
        required={true}
      />
      <TextInput
        cmsData={cmsData}
        name="time"
        label="Ønsket tidspunkt på dagen"
        defaultValue={time ?? ""}
        errors={errors?.time}
        required={false}
      />
    </>
  );
}
